'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { cn } from '@core/utils';
import { useState } from 'react';
import { LoadingPageTemplate } from '@/components/client';
interface CommentFormProps {
  onSubmit?: (comment: string) => void;
  onClose?: () => void;
  loading?: boolean;
  isEdit?: boolean;
  initialComment?: string;
}
export const CommentForm = t0 => {
  const $ = _c(33);
  const {
    onSubmit,
    onClose,
    loading,
    isEdit,
    initialComment
  } = t0;
  const [comment, setComment] = useState(initialComment ?? "");
  let t1;
  if ($[0] !== comment || $[1] !== loading || $[2] !== onSubmit) {
    t1 = () => {
      if (loading) {
        return;
      }
      setComment("");
      onSubmit?.(comment);
    };
    $[0] = comment;
    $[1] = loading;
    $[2] = onSubmit;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleSubmit = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e => {
      if (e.target.value.length > 100) {
        return;
      }
      setComment(e.target.value);
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleChange = t2;
  let t3;
  if ($[5] !== comment) {
    t3 = comment.trim();
    $[5] = comment;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const isDisabledSubmitButton = !t3;
  const submitButtonText = isEdit ? "\uC218\uC815" : "\uB4F1\uB85D";
  const isShowCancelButton = isEdit;
  let t4;
  if ($[7] !== loading) {
    t4 = cn("flex w-full flex-col gap-8 rounded-small border border-Gray-300 px-16 py-12", {
      "pointer-events-none": loading
    });
    $[7] = loading;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== comment) {
    t5 = <textarea className="min-h-80 resize-none text-Gray-900 outline-none placeholder:font-400 placeholder:text-Gray-550 placeholder:typo-body3" placeholder={"\uC751\uC6D0\uC758 \uB9D0\uC744 \uB0A8\uACA8\uC8FC\uC138\uC694"} value={comment} onChange={handleChange} maxLength={100} />;
    $[9] = comment;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== comment.length) {
    t6 = <p className="font-400 text-Gray-550 typo-caption1">{comment.length}/100</p>;
    $[11] = comment.length;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== isShowCancelButton || $[14] !== onClose) {
    t7 = isShowCancelButton && <Button theme="sub-fill" dimensions="H32" onClick={() => onClose?.()}>취소</Button>;
    $[13] = isShowCancelButton;
    $[14] = onClose;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== handleSubmit || $[17] !== isDisabledSubmitButton || $[18] !== submitButtonText) {
    t8 = <Button dimensions="H32" disabled={isDisabledSubmitButton} onClick={handleSubmit}>{submitButtonText}</Button>;
    $[16] = handleSubmit;
    $[17] = isDisabledSubmitButton;
    $[18] = submitButtonText;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t7 || $[21] !== t8) {
    t9 = <div className="flex items-center gap-4">{t7}{t8}</div>;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t6 || $[24] !== t9) {
    t10 = <div className="flex items-end justify-between">{t6}{t9}</div>;
    $[23] = t6;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== loading) {
    t11 = loading && <LoadingPageTemplate blur={true} fadeIn={true} />;
    $[26] = loading;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t10 || $[29] !== t11 || $[30] !== t4 || $[31] !== t5) {
    t12 = <article className={t4}>{t5}{t10}{t11}</article>;
    $[28] = t10;
    $[29] = t11;
    $[30] = t4;
    $[31] = t5;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  return t12;
};